
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/renters",
      function () {
        return require("private-next-pages/renters.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/renters"])
      });
    }
  